import React from 'react';
import styled from 'styled-components';

const StyledCard = styled.div<{ $pad?: boolean }>`
  background: var(--surface);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-1);
  padding: ${({ $pad }) => ($pad !== false ? 'var(--s-5)' : '0')};
`;

interface ScCardProps extends React.HTMLAttributes<HTMLDivElement> {
  pad?: boolean;
}

const ScCard: React.FC<ScCardProps> = ({ pad = true, children, ...rest }) => (
  <StyledCard $pad={pad} {...rest}>
    {children}
  </StyledCard>
);

export default ScCard;
